import { LoginDetails } from './login-details.model';

export class Lead extends LoginDetails {
	public Name: string;
	public Email: string;
	public City: string;
    public CategoryCode: string;
	public LeadSource: string;
	public UtmSource: string;
	public UtmTerm: string;
	public UtmMedium: string;
	public UtmCampaign: string;
	public UtmContent: string;
	public UtmPromo: string;
	public UtmDeviceId: string;
	public UtmAppid: string;
	public UtmAdvertisementId: string;
	public UtmAppsflyerid: string;
	public UtmOSversion: string;
	public UtmATTConsent: string;

	public Otp: string;
	public PartnerCategory: string;
	public IsConsent?:boolean;
	// adde by sunil on 30062023
    public PinCode:string;
	 public agreeTerms:boolean;
	 public Distict:string;


	constructor(){
		super()
		
		this.agreeTerms=true;
		this.Distict="";
	}
}
